import { GET_DEPT_LIST, EDIT_DEPT, ADD_DEPT } from 'fixtures/actions'

let initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DEPT_LIST:
      return [...action.payload];
    case ADD_DEPT:
      return [action.payload, ...state];
    case EDIT_DEPT:
      return [...state.map(dept => {
        if (dept.id === action.payload.id) {
          dept = action.payload
        }
        return dept
      })];
    default:
      return state;
  }
};
